"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeRate = exports.Rate = exports.TokenAmount = exports.Token = void 0;
const big_js_1 = __importDefault(require("big.js"));
class Token {
    constructor(mint, mintInfo) {
        this.mint = mint;
        this.mintInfo = mintInfo;
    }
}
exports.Token = Token;
class TokenAmount {
    constructor(lamports, decimals, mint) {
        this.lamports = lamports;
        this.decimals = decimals;
        this.mint = mint;
    }
    static fromTokenAccountInfo(tokenAccountInfo, decimals) {
        return new TokenAmount((0, big_js_1.default)(tokenAccountInfo.amount.toString()), decimals, tokenAccountInfo.mint);
    }
    static fromToken(token, lamports) {
        return new TokenAmount(lamports, token.mintInfo.decimals, token.mint);
    }
    static zero(decimals, mint) {
        return new TokenAmount((0, big_js_1.default)(0), decimals, mint);
    }
    getAmount() {
        return this.lamports.div((0, big_js_1.default)(10).pow(this.decimals)).toNumber();
    }
    static op_verify(a, b) {
        if (b.decimals != a.decimals) {
            throw Error(`Decimals do not match: ${b.decimals} / ${a.decimals}`);
        }
        if (b.mint && a.mint && !b.mint.equals(a.mint)) {
            throw Error(`Mints do not match: ${b.mint} / ${a.mint}`);
        }
    }
    sub(a) {
        TokenAmount.op_verify(this, a);
        return new TokenAmount(this.lamports.sub(a.lamports), this.decimals, this.mint);
    }
    add(a) {
        TokenAmount.op_verify(this, a);
        return new TokenAmount(this.lamports.add(a.lamports), this.decimals, this.mint);
    }
}
exports.TokenAmount = TokenAmount;
class Rate {
    constructor(value) {
        this.value = value;
    }
    static zero() {
        return new Rate((0, big_js_1.default)(0));
    }
    static fromPercent(percent_value) {
        return new Rate((0, big_js_1.default)(percent_value).div(100));
    }
    static fromBps(bps_value) {
        return new Rate((0, big_js_1.default)(bps_value).div(10000));
    }
    toBig() {
        return this.value;
    }
    toNumber() {
        return this.value.toNumber();
    }
    asPercent() {
        return this.value.mul(100);
    }
    asBps() {
        return this.value.mul(10000);
    }
    mul(m) {
        const result = m instanceof Rate ? this.value.mul(m.toBig()) : this.value.mul(m);
        return new Rate(result);
    }
    add(a) {
        const result = a instanceof Rate ? this.value.add(a.toBig()) : this.value.add(a);
        return new Rate(result);
    }
    div(d) {
        const result = d instanceof Rate ? this.value.div(d.toBig()) : this.value.div(d);
        return new Rate(result);
    }
}
exports.Rate = Rate;
class ExchangeRate extends Rate {
    constructor(value, baseToken, quoteToken) {
        super(value);
        this.baseToken = baseToken;
        this.quoteToken = quoteToken;
    }
    convertToQuote(baseAmount) {
        if (baseAmount.mint && !baseAmount.mint.equals(this.baseToken.mint)) {
            throw Error(`Mints do not match: ${this.baseToken.mint} / ${baseAmount.mint}`);
        }
        return TokenAmount.fromToken(this.quoteToken, baseAmount.lamports.div(this.value));
    }
    convertToBase(quoteAmount) {
        if (quoteAmount.mint &&
            !quoteAmount.mint.equals(this.quoteToken.mint)) {
            throw Error(`Mints do not match: ${this.quoteToken.mint} / ${quoteAmount.mint}`);
        }
        return TokenAmount.fromToken(this.baseToken, quoteAmount.lamports.mul(this.value));
    }
}
exports.ExchangeRate = ExchangeRate;
//# sourceMappingURL=utils.js.map